import { useQueryClient } from '@tanstack/react-query'
import { LectureQuestionInsertRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useQuestionsInsert = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureQuestionInsertRequest>()

  const insertQuestion = async (requestData: LectureQuestionInsertRequest) => {
    const result = await mutation.mutateAsync({
      url: '/lectures/questions/insert',
      data: requestData,
    })

    queryClient.invalidateQueries({ queryKey: ['questionsDetail'] })
    queryClient.invalidateQueries({ queryKey: ['lecture-list'] })

    return result
  }

  return {
    insertQuestion,
    isPending: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  }
}
